import { images } from "../constants";

const historyDataData = {
    title: 'historyData.title',
    page: 'historyData.page',
    heading: 'historyData.heading',
    subHeading: 'historyData.subHeading',
    intro: 'historyData.intro',

    blocks: [
        {
            id: 1,
            image: images.history1,
            iconType: 'historyData',
            title: 'historyData.blocks.0.title',
            paragraphs: [ // <--- POPRAWIONO (było paragraphss)
                'historyData.blocks.0.paragraphs.0'
            ],
            reverse: false
        },
        {
            id: 2,
            image: images.history2,
            iconType: 'landmark',
            title: 'historyData.blocks.1.title',
            paragraphs: [ // <--- POPRAWIONO (było paragraphss)
                'historyData.blocks.1.paragraphs.0',
                'historyData.blocks.1.paragraphs.1'
            ],
            reverse: true
        },
        {
            id: 3,
            image: images.history3,
            iconType: 'historyData',
            title: 'historyData.blocks.2.title',
            paragraphs: [ // <--- POPRAWIONO (było paragraphss)
                'historyData.blocks.2.paragraphs.0'
            ],
            reverse: false
        }
    ],

    heritage: {
        title: 'historyData.heritage.title',
        intro: 'historyData.heritage.intro',
        list: [ // <--- POPRAWIONO (było lists)
            'historyData.heritage.list.0',
            'historyData.heritage.list.1',
            'historyData.heritage.list.2',
            'historyData.heritage.list.3'
        ]
    },

    mission: {
        title: 'historyData.mission.title',
        text: 'historyData.mission.text',
        slogan: 'historyData.mission.slogan'
    },

    gallery: [
        images.gallery1,
        images.gallery2,
        images.gallery3,
        images.gallery4,
        images.gallery5,
        images.gallery6,
        images.gallery7,
        images.gallery8,
        images.gallery9
    ],
};

export default historyDataData;